import { Navigate, Outlet } from 'react-router-dom'
import { useMediaQuery, useTheme } from '@mui/material'
import { useOrgTypeCheck } from '../components/AccountTypeCheck'
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner'
import { SCHOOL_LOADING_ERROR_CODES } from '../../../components/LoadingSpinner/loadingErrorCodes'
import { memo } from 'react'
import { useCentreCheck } from './hooks/useCentreCheck'

const ECCDashboardLayout = () => {
    const loading = useOrgTypeCheck('childcareCentre')
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

    useCentreCheck()

    if (isMobile) {
        return <Navigate to={'/download'} />
    }

    if (loading)
        return (
            <LoadingSpinner
                fillViewPortHeight
                fillViewPortWidth
                errorCode={SCHOOL_LOADING_ERROR_CODES.SCHOOL_TYPE_CHECK.code}
            />
        )
    return <Outlet />
}

export default memo(ECCDashboardLayout)
